module.exports = __webpack_public_path__ + "static/media/cojines.eab5cfd7.png";